<template>
  <div
    :class="{
      [$style.cell]: true,
      [$style.align_right]: isAlignRight,
      [$style.right_border]: skin === 'horizontal-borders' && !isLastColumn,
      [$style.can_sort]: isCanSort,
      [$style.is_sorted]: !!sortDirection,
    }"
    :style="{ ...cellStyles }"
  >
    <div
      v-if="isAlignRight"
      :class="$style.icons"
    >
      <svg-sprite
        v-if="sortDirection"
        :class="$style.sorting_icon"
        type="regular"
        :size="16"
        :name="{asc: 'priority-2', desc: 'priority'}[sortDirection]"
        color="#808080"
      />
      <svg-sprite
        v-else
        :class="[$style.sorting_icon, $style.hover]"
        type="regular"
        :size="16"
        :name="'priority'"
        color="#B2B2B2"
      />
    </div>
    <tooltip
      :content="cell.column.columnDef.header"
      :position="'bottom'"
      :hide="!isHeaderOverflowed"
      :class="$style.header_tooltip"
    >
      <template #body>
        <span
          ref="headerText"
          :class="$style.header_text"
        >
          {{ cell.column.columnDef.header }}
        </span>
      </template>
    </tooltip>
    <tooltip
      v-if="cell.column.columnDef.headerIconTooltip"
      :class="$style.tooltip_wrapper"
      :content="cell.column.columnDef.headerIconTooltip.content"
      :position="'bottom'"
    >
      <template #body>
        <svg-sprite
          type="regular"
          :size="16"
          :name="cell.column.columnDef.headerIconTooltip.iconName"
          :color="cell.column.columnDef.headerIconTooltip.iconColor"
        />
      </template>
    </tooltip>
    <div
      v-if="!isAlignRight"
      :class="$style.icons"
    >
      <svg-sprite
        v-if="sortDirection"
        :class="$style.sorting_icon"
        type="regular"
        :size="16"
        :name="{asc: 'priority-2', desc: 'priority'}[sortDirection]"
        color="#808080"
      />
      <svg-sprite
        v-else
        :class="[$style.sorting_icon, $style.hover]"
        type="regular"
        :size="16"
        :name="'priority'"
        color="#B2B2B2"
      />
    </div>
  </div>
</template>

<script>
import tooltip from '$$vueCmp/tooltips/tooltip.vue';

export default {
  components: { tooltip },
  props: {
    cell: { type: Object, required: true },
    width: { type: String, required: true, default: '100%' },
    skin: { type: String, required: false, default: '' },
    isFirstColumn: { type: Boolean, required: false, default: false },
    isLastColumn: { type: Boolean, required: false, default: false },
    isCanSort: { type: Boolean, required: false, default: false },
    sortDirection: {
      type: [Boolean, String],
      default: false,
      validator: v => v === false || v === 'asc' || v === 'desc',
    },
  },
  data() {
    return {
      isHeaderOverflowed: false,
    };
  },
  computed: {
    isAlignRight() {
      if (this.cell.column.columnDef.align === 'right') {
        return true;
      }

      return false;
    },
    cellStyles() {
      let styles = { width: this.width };

      if (this.isFirstColumn) {
        styles = {
          ...styles,
          paddingLeft: '28px',
        };
      }

      if (this.isLastColumn) {
        styles = {
          ...styles,
          paddingRight: '28px',
        };
      }

      return styles;
    },
  },
  mounted() {
    this.checkHeaderOverflow();
    window.addEventListener('resize', this.checkHeaderOverflow);
  },
  updated() {
    this.$nextTick(this.checkHeaderOverflow);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkHeaderOverflow);
  },
  methods: {
    checkHeaderOverflow() {
      const el = this.$refs.headerText;

      if (!el) {
        this.isHeaderOverflowed = false;

        return;
      }

      this.isHeaderOverflowed = el.scrollWidth > el.clientWidth;
    },
  },
};
</script>

<style module lang="less">
  @import '../../../../less/_mixins.less';
  @import '../../../../less/_fonts.less';

  .cell {
    display: flex;
    align-items: center;
    padding: 6px 8px;
    cursor: default;
    height: 100%;

    .icons {
      display: none;
      flex-shrink: 0;
    }

    &.right_border {
      border-right: 1px solid #E5E5E5;
    }

    .header_tooltip {
      flex: 1 1 0;
      min-width: 0;
      max-width: 100%;
    }

    .header_text {
      .FontLatoBold;
      font-size: 12px;
      line-height: 18px;
      color: #808080;
      display: block;
      width: 100%;
      min-width: 0;
      text-align: left;
      padding: 3px 4px;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .tooltip_wrapper {
      width: auto !important;
      padding-left: 4px;

      & > div {
        display: flex;
      }
    }

    &.can_sort {
      cursor: pointer;

      .icons {
        .sorting_icon {
         // margin: 0 4px;
        }

        .sorting_icon.hover {
          opacity: 0;
        }
      }

      &:hover {
        background: #F2F2F2;

        .icons {
          display: flex;
        }

        .sorting_icon.hover {
          opacity: 1;
        }
      }
    }

    &.is_sorted {
      .icons {
        display: flex;
      }
    }

    &.align_right {
      justify-content: flex-end;

      .header_tooltip {
        display: flex;
        justify-content: flex-end;
      }

      .header_text {
        text-align: right !important;
      }
    }
  }
</style>
